import { Injectable } from '@angular/core';
import { BaseHttpService } from '@common/services/REST/base.http.service';
import { type Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ProductCardHttpService extends BaseHttpService {
    public setDigitalProductUrl({ name, url }: { name: string; url: string }): Observable<any> {
        return this.http.post<{ name: string; url: string }>(this.formatApiUrl('digital-products'), {
            name,
            url,
        });
    }

    public updateDigitalProductData(
        { name, url }: { name: string; url: string },
        digitalProductId: string
    ): Observable<any> {
        return this.http.put<{ name: string; url: string }>(this.formatApiUrl(`digital-products/${digitalProductId}`), {
            name,
            url,
        });
    }

    public getDigitalProductData(digitalProductId: string): Observable<any> {
        return this.http.get(this.formatApiUrl(`digital-products/${digitalProductId}`));
    }
}
